import { post, get } from '../../../components/hooks/apiFetch';

export const useUniversalSummarizeResumeApi = () => {
    const submitUniversalSummarizeResumeRequest = async (filesWithFormats, promptName, promptText, promptGuid, comment = '', version = 1, startTime = '') => {
        comment ??= '';
        const formData = new FormData();
        filesWithFormats.forEach((item, index) => {
            formData.append(`Files[${index}].File`, item.file, item.file.name);
            formData.append(`Files[${index}].OutputFormat`, item.outputFormat);
            if (item.templateName && item.templateName.trim() !== '') {
                formData.append(`Files[${index}].TemplateName`, item.templateName);
            }
        });

        formData.append("Options.PromptName", promptName);
        formData.append("Options.PromptText", promptText);
        formData.append("Options.Comment", comment.trim());
        formData.append("Options.Version", version);
        formData.append("Options.StartTime", startTime);

        if (promptGuid != null) {
            formData.append("Options.PromptGuid", promptGuid);
        }

        const result = await post("/api/universalsummarizeresume", formData);

        return {
            id: result.id,
            identifier: result.identifier
        };
    };

    const cancelUniversalSummarizeResumeTask = async (inputIdentifier) => {
        await get(`/api/universalsummarizeresume/cancel/${encodeURIComponent(inputIdentifier)}`);
        return true;
    };

    return { submitUniversalSummarizeResumeRequest, cancelUniversalSummarizeResumeTask };
};